import React from 'react';
import styled from 'styled-components';

import { Link, Portal } from '@lt/components';
import { Trans, useTranslation } from '@lt/localization';
import { useShowBannerController } from 'src/hooks/useShowBannerController';
import {
  BUTTON_DATA_TEST_ID,
  COOKIE_AGREEMENT,
  DATA_TEST_ID,
  RECOMENDATION_TECHNOLOGIES_AGREEMENT,
  KEY_COOKIE,
} from './constants';

interface CookiesBannerProps {
  isMobile: boolean;
}
export const CookiesBanner = ({
  isMobile,
}: CookiesBannerProps): JSX.Element | null => {
  const { t } = useTranslation();

  const { isShowBanner, handleCloseBanner } =
    useShowBannerController(KEY_COOKIE);

  if (!isShowBanner) {
    return null;
  }

  return (
    <Portal>
      <Container data-testid={DATA_TEST_ID} $isMobile={isMobile}>
        <Content>
          <Trans
            i18nKey="cookies_banner.description"
            components={{
              FirstLink: <Link href={COOKIE_AGREEMENT} />,
              SecondLink: <Link href={RECOMENDATION_TECHNOLOGIES_AGREEMENT} />,
            }}
          />
        </Content>
        <StyledButton
          onClick={handleCloseBanner}
          data-testid={BUTTON_DATA_TEST_ID}
          $isMobile={isMobile}
        >
          {t('cookies_banner.agree_button')}
        </StyledButton>
      </Container>
    </Portal>
  );
};

const Container = styled.div<{ $isMobile: boolean }>`
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 11000; //чтобы перекрыть кнопки навигации на моб странице поиска
  width: 100vw;
  padding: 16px;
  background-color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 16px;

  ${({ $isMobile }) => $isMobile && 'flex-direction: column;'}
`;

const Content = styled.div`
  display: inline-block;
  color: #17181a;
  font-size: 14px;
  line-height: 16px;
  font-weight: 400;
`;

const StyledButton = styled.button<{ $isMobile: boolean }>`
  outline: none;
  padding: 9px 12px;
  border-radius: 4px;
  border: 1px solid #007aff;
  color: #007aff;
  font-size: 14px;
  line-height: 16px;
  background-color: transparent;
  cursor: pointer;

  ${({ $isMobile }) => $isMobile && 'width: 100%;'}
`;
